import { action, observable } from 'mobx';
import { Product as ProductType } from '@/services/types';

export class Product {
  @observable accessor products: ProductType[] = [];

  @action
  setProducts(products: ProductType[]) {
    this.products = products;
  }

  @action
  getProducts() {
    return this.products;
  }

  getProductNameById(productId: string): string {
    const product = this.products.find(item => item.productId === productId);
    return product?.productName || '';
  }
}

export default new Product();
